import { Alert } from '@ksyos/design-system';
import { translateKey } from '../../../../../translate';
import { ScoreIndicator } from '../../../../elements/scoreIndicator/ScoreIndicator';

interface IScoreRange {
    color: 'danger' | 'emergency' | 'normal';
    maxValue: number;
    minValue: number;
}

interface IInterapy4DklScore {
    labelKey: string;
    maxValue: number;
    scoreRanges: IScoreRange[];
}

const distress4DklScore: IInterapy4DklScore = {
    labelKey: 'interapy.distress',
    maxValue: 32,
    scoreRanges: [
        { minValue: 0, maxValue: 10, color: 'normal' },
        { minValue: 11, maxValue: 20, color: 'danger' },
        { minValue: 21, maxValue: 32, color: 'emergency' },
    ],
};

const depressie4DklScore: IInterapy4DklScore = {
    labelKey: 'interapy.depression',
    maxValue: 12,
    scoreRanges: [
        { minValue: 0, maxValue: 2, color: 'normal' },
        { minValue: 3, maxValue: 5, color: 'danger' },
        { minValue: 6, maxValue: 12, color: 'emergency' },
    ],
};

const angst4DklScore: IInterapy4DklScore = {
    labelKey: 'interapy.fear',
    maxValue: 24,
    scoreRanges: [
        { minValue: 0, maxValue: 3, color: 'normal' },
        { minValue: 4, maxValue: 9, color: 'danger' },
        { minValue: 10, maxValue: 24, color: 'emergency' },
    ],
};

const somatisatie4DklScore: IInterapy4DklScore = {
    labelKey: 'interapy.somatisation',
    maxValue: 32,
    scoreRanges: [
        { minValue: 0, maxValue: 10, color: 'normal' },
        { minValue: 11, maxValue: 20, color: 'danger' },
        { minValue: 21, maxValue: 32, color: 'emergency' },
    ],
};

export type Interapy4DklScoreType = 'depressie' | 'distress' | 'angst' | 'somatisatie';

export interface IInterapy4DklScoreIndicatorProps {
    interapy4DklScoreType: Interapy4DklScoreType;
    norm: string;
    score: number;
}

export function Interapy4DklScoreIndicator(props: IInterapy4DklScoreIndicatorProps) {
    let interapy4DklScore: IInterapy4DklScore | undefined;
    switch (props.interapy4DklScoreType) {
        case 'depressie':
            interapy4DklScore = depressie4DklScore;
            break;
        case 'distress':
            interapy4DklScore = distress4DklScore;
            break;
        case 'angst':
            interapy4DklScore = angst4DklScore;
            break;
        case 'somatisatie':
            interapy4DklScore = somatisatie4DklScore;
            break;
        default:
            break;
    }

    if (!interapy4DklScore) {
        return null;
    }

    const scoreRange = getRange(interapy4DklScore.scoreRanges, props.score);
    if (scoreRange) {
        return (
            <ScoreIndicator
                color={scoreRange.color}
                label={translateKey(interapy4DklScore.labelKey)}
                maxValue={scoreRange.maxValue}
                minValue={scoreRange.minValue}
                percentage={(props.score * 100) / interapy4DklScore.maxValue}
                result={props.norm.replace(/\s\[.*\]/g, '')}
                value={props.score}
            />
        );
    } else {
        return (
            <Alert appearance="warning">{`${translateKey(
                interapy4DklScore.labelKey
            )}: geen interpretatie van 4DKL-score mogelijk`}</Alert>
        );
    }
}

function getRange(ranges: IScoreRange[], score: number) {
    for (const range of ranges) {
        if (score >= range.minValue && score <= range.maxValue) {
            return range;
        }
    }
}
